module.exports = __webpack_public_path__ + "img/2.5acd4a5f.png";